module.exports = __webpack_public_path__ + "static/media/chevron-open.fe043b10.svg";